import { TypeEnum } from "@/types/types";
import styles from "../page-searchbar.module.css";
import { IoIosArrowDown } from "react-icons/io";

export default function TypeSelectorServer({
  t,
  type,
}: {
  t: any;
  type: TypeEnum;
}) {
  return (
    <div className={`${styles.selectWrapper} ${styles.typeItemWrapper}`}>
      <button className={styles.pill}>
        <div className={styles.textWrapper}>
          <span>{t(type)}</span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
    </div>
  );
}
